import React, { useEffect } from 'react';
import './App.css';
const firebase = require('firebase');

const firebaseConfig = {
  apiKey: 'AIzaSyA3S-IdNNd7NABXSRCz-H6tCs0lCEvlddo',
  authDomain: 'playfora-dev.firebaseapp.com',
  databaseURL: 'https://playfora-dev.firebaseio.com',
  projectId: 'playfora-dev',
  storageBucket: 'playfora-dev.appspot.com',
  messagingSenderId: '103824779069',
  appId: '1:103824779069:web:71b09aed24693ddfc30754',
  measurementId: 'G-4TYL3TZ65Y',
};
firebase.initializeApp(firebaseConfig);
const firebaseui = require('firebaseui');
const messaging = firebase.messaging();

const callBacks = {
  signInSuccessWithAuthResult: (authResult, redirectURL) => {
    console.log(authResult);
    firebase
      .auth()
      .currentUser.getIdToken(/* forceRefresh */ true)
      .then(function (idToken) {
        // Send token to your backend via HTTPS
        // ...
        console.log('idToken: ', idToken);
        return true;
      })
      .catch(function (error) {
        // Handle error
        return false;
      });
    //console.log(authResult.currentUser);
  },
};

function App() {
  useEffect(() => {
    var ui = new firebaseui.auth.AuthUI(firebase.auth());

    ui.start('#firebaseui-auth-container', {
      signInSuccessUrl: '/success',
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          signInMethod:
            firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
        },
        firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      ],
      callbacks: callBacks,
      // Other config options...
    });

    // Get registration token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    messaging
      .getToken({
        vapidKey:
          'BMW4jhSiWrhecbeG28xvMd4V2o_GoNZ-_8kIRd7IXUcOyMTDEGbGex0PAT-qMpc0S_bVirbc-samghZJsI_L_5U',
      })
      .then((currentToken) => {
        if (currentToken) {
          // Send the token to your server and update the UI if necessary
          // ...
          console.log('currentToken', currentToken);
        } else {
          // Show permission request UI
          console.log(
            'No registration token available. Request permission to generate one.'
          );
          // ...
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        // ...
      });

    messaging.onMessage((payload) => {
      console.log('Message received. ', payload);
      navigator.serviceWorker
        .getRegistration('/firebase-cloud-messaging-push-scope')
        .then((registration) => {
          const notificationTitle = payload.notification.title;
          const notificationOptions = {
            body: payload.notification.body,
            icon: payload.notification.image,
          };

          registration.showNotification(notificationTitle, notificationOptions);
        });
      // Update the UI to include the received message.
    });

    return () => {
      console.log('cleanup');
    };
  }, []);

  return (
    <React.Fragment>
      <div className="App" id="firebaseui-auth-container"></div>
    </React.Fragment>
  );
}

export default App;
